const Logo = () => {
  return (
    <svg
      width='165'
      height='24'
      viewBox='0 0 165 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M50.4973 19.227H47.7114L44.4023 4.77441H47.5414L49.464 14.283L52.2107 4.77441H54.8527L57.6778 14.3484L59.5874 4.77441H62.7525L59.4173 19.227H56.6053L53.5447 9.27367L50.4842 19.227H50.4973Z'
        fill='white'
      />
      <path
        d='M72.8616 19.2261H63.9416V17.3427L68.7809 11.6401C69.6834 10.5938 70.115 9.71749 70.115 8.77578C70.115 7.59865 69.2518 7.01008 68.3101 7.01008C67.3683 7.01008 66.5967 7.61173 66.5051 8.77578H63.9023C63.9023 6.27765 65.9558 4.59042 68.4539 4.59042C70.9521 4.59042 73.0186 6.39536 73.0186 8.77578C73.0186 10.6854 71.763 12.1633 70.8343 13.262L67.8654 16.7541H72.8486V19.2261H72.8616Z'
        fill='white'
      />
      <path
        d='M85.9273 8.51437C85.2994 7.53342 84.5409 7.04949 83.076 7.04949C81.755 7.04949 81.0487 7.65114 81.0487 8.64516C81.0487 9.76997 81.9642 10.2801 83.9 10.764C86.9213 11.5226 88.2815 12.6474 88.2815 15.2109C88.2815 17.5783 86.6859 19.4225 83.2983 19.4225C80.7609 19.4225 79.0083 18.7293 77.7266 17.0551L79.9631 15.4987C80.7348 16.4665 81.6242 16.9374 83.1021 16.9374C84.7763 16.9374 85.3387 16.205 85.3387 15.3287C85.3387 14.3216 84.737 13.7591 82.3828 13.1444C79.5315 12.3858 78.1059 11.0256 78.1059 8.64516C78.1059 6.26474 79.61 4.57751 83.0498 4.57751C85.3518 4.57751 87.0913 5.34919 88.1246 6.94486L85.9273 8.51437Z'
        fill='white'
      />
      <path
        d='M98.4329 19.2264H95.7778V13.0922C95.7778 11.4181 95.1239 10.8687 94.1822 10.8687C93.2405 10.8687 92.5211 11.575 92.5211 13.066V19.2264H89.8398V8.7499H92.4557V9.62621C92.8481 9.07688 93.6067 8.55371 94.7838 8.55371C96.0394 8.55371 97.0727 9.03764 97.7136 9.95319C98.3806 9.14228 99.4139 8.55371 100.735 8.55371C103.024 8.55371 104.358 9.94011 104.358 12.6606V19.2133H101.677V13.0791C101.677 11.5096 101.127 10.8557 100.068 10.8557C99.1 10.8557 98.4329 11.5619 98.4329 13.053V19.2133V19.2264Z'
        fill='white'
      />
      <path
        d='M109.368 12.9353H111.434V12.3336C111.434 11.1565 111.081 10.7772 109.577 10.7772C108.557 10.7772 108.047 10.9211 107.615 11.6143L105.732 10.2932C106.503 9.01148 107.68 8.55371 109.838 8.55371C112.546 8.55371 114.063 9.35154 114.063 12.3467V19.2133H111.447V18.2977C111.029 19.004 110.401 19.4095 109.184 19.4095C107 19.4095 105.496 18.2585 105.496 16.1266C105.496 13.9947 107.17 12.9483 109.368 12.9483V12.9353ZM111.434 14.9102H109.668C108.583 14.9102 108.099 15.2634 108.099 16.0874C108.099 16.9113 108.714 17.2645 109.629 17.2645C110.846 17.2645 111.434 16.7413 111.434 15.3157V14.9233V14.9102Z'
        fill='white'
      />
      <path
        d='M123.125 8.74979H124.459V6.44785H127.114V8.74979H129.168V11.0125H127.114V15.394C127.114 16.4404 127.323 16.8851 128.304 16.8851H129.168V19.2263H128.043C125.505 19.2263 124.459 18.52 124.459 15.8126V11.0125H123.125V8.74979Z'
        fill='white'
      />
      <path
        d='M135.094 10.5162H140.103V4.77441H143.033V19.227H140.103V12.9882H135.094V19.227H132.164V4.77441H135.094V10.5162Z'
        fill='white'
      />
      <path
        d='M153.68 19.2269H151.064V18.3505C150.62 19.0568 150.057 19.423 148.671 19.423C146.552 19.423 144.812 18.3767 144.812 15.3031V8.76346H147.494V14.8976C147.494 16.5587 148.082 17.1211 149.194 17.1211C150.437 17.1211 151.012 16.3625 151.012 14.9238V8.76346H153.667V19.2399L153.68 19.2269Z'
        fill='white'
      />
      <path
        d='M157.877 9.40447C158.44 8.80282 159.237 8.56739 160.14 8.56739C162.651 8.56739 164.26 10.2023 164.26 13.3413V14.5969C164.26 17.4613 162.9 19.4101 160.14 19.4101C159.12 19.4101 158.374 19.1354 157.877 18.5992V19.227H155.34V4.77441H157.877V9.40447ZM161.605 14.5054V13.4198C161.605 11.7456 161.055 10.817 159.734 10.817C158.413 10.817 157.877 11.7326 157.877 13.4198V14.5054C157.877 16.0095 158.335 17.1474 159.734 17.1474C161.134 17.1474 161.605 16.0226 161.605 14.5054Z'
        fill='white'
      />
      <path
        d='M118.928 12.5436C118.706 12.9621 118.601 13.6161 118.601 14.5054V19.2271H115.711V8.75058H118.458V10.6732C119.229 9.09064 120.629 8.75058 122.107 8.75058V11.0133C120.707 11.0133 119.582 11.2487 118.942 12.5436H118.928Z'
        fill='white'
      />
      <path
        d='M16.3896 5.07475L13.5645 7.06279L17.9068 10.1233L14.3362 12.6607L6.41016 7.06279L12.8059 2.53737L14.6239 1.26869L16.3896 0L33.9289 12.3991L30.3452 14.9365L16.3896 5.07475Z'
        fill='white'
      />
      <path
        d='M27.5188 16.9239L25.7269 18.2057L23.9481 19.4613L21.123 21.4624L19.0042 22.9665L17.5393 23.9998L0 11.6007L3.58372 9.06329L17.5393 18.925L20.3644 16.9239L16.506 14.2034L20.0767 11.6661L27.5188 16.9239Z'
        fill='white'
      />
    </svg>
  )
}

export default Logo
